export default __webpack_public_path__ + "static/media/sprkl_v2.a5f3fc97.jpg";